import {useSelector} from "react-redux";

export const ArchiveLists = ({handleRestoreList}) => {
    const lists = useSelector((state) => state.boards.boardLists || []);
    const archivedLists = lists.filter((el) => el.is_archive);

    return (
        <div className="closeBoardModal__body archiveItemsModal__body">
            {archivedLists.length > 0 ? (
                archivedLists.map((list) => (
                    <div className="archiveItemsModal__row" key={list.id}>
                        <span>{list.title}</span>

                        <button
                            type="button"
                            className="archiveItemsModal__restore"
                            onClick={() => handleRestoreList(list.id)}
                        >
                            Restore
                        </button>
                    </div>
                ))
            ) : (
                <p>No archived items yet.</p>
            )}
        </div>
    )
}